enum TrendChartItemType {
  //Any item published prior to the latest published item
  OlderPublished = "olderPublished",

  //The latest published item
  LatestPublished = "latestPublished",

  //The latest unpublished item, which is only returned if there is an unpublished item that is newer than the latest published item
  Unpublished = "unpublished",

  //The projected item
  Projected = "projected",

  Termed = "termed",

  ProjectedTermed = "projectedTermed",
}

export {
  TrendChartItemType,
};
